import { useState, useEffect, useCallback } from 'react'
import { useFetch } from "use-http";

import
{

   Chip
} from '@mui/material';

const UnreadedTicketCounter = () =>
{
   const fetcher = useFetch(process.env.REACT_APP_BASE_API_URL, { cachePolicy: 'no-cache' });
   const [unreaded, setUnreaded] = useState(0);

   const fetchUnreaded = useCallback(async () =>
   {
      const num = await fetcher.get('/api/comunicazioni/summary/');
      console.log('numnum', num);

      if (fetcher.error)
      {
         console.log('Problema durante il recupero dei dati per il controllo delle anomalie', fetcher.error);
         return null;
      }

      setUnreaded(num?.result);
   }, [fetcher])

   useEffect(() =>
   {

      let interval;

      interval = setInterval(() =>
      {
         fetchUnreaded();
      }, 60 * 2 * 1000);

      fetchUnreaded();

      return () =>
      {
         clearInterval(interval);
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      unreaded ? (
         <Chip
            label={unreaded}
            color='error'
         />
      ) : null

   )
}

export default UnreadedTicketCounter;